module.exports = __webpack_public_path__ + "images/category_lp/pc/fukidashi_ef8d0e40f3028d181efe2c9797d57827.png";